import React from 'react';
import './MessageCenter.css';
import Message from '../UI/Message';

const MessageCenter = () => {
	return (
		<div className='messagecenter-main-box'>
			<Message>
				Centrum wiadomości zostanie dodane w przyszłośći obecnie prosimy
				kontaktować się pod maila wosmateusz2@gmail.com
			</Message>
		</div>
	);
};

export default MessageCenter;
